import { Link } from "react-router-dom";
import SunAccent from "@/components/feature/SunAccent";

export default function ShareStoryHero() {
  return (
    <section className="relative min-h-[62vh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20candid%20scene%20of%20a%20visitor%20writing%20in%20a%20small%20notebook%20while%20sitting%20on%20a%20wooden%20bench%20beside%20a%20green%20paddy%20field%20in%20rural%20India%2C%20soft%20late%20afternoon%20light%2C%20painterly%20stylized%20earthy%20tones%2C%20reflective%20storytelling%20mood%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&width=1920&height=1080&seq=share-story-hero&orientation=landscape"
          width={1920}
          height={1080}
          alt="A visitor writing their story beside a green paddy field"
          title="Share your story with Rythugaru"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-12 md:pb-16">
        <nav className="flex items-center gap-2 text-xs md:text-sm text-background-200 mb-6 flex-wrap">
          <Link to="/" className="hover:text-background-50 transition-colors">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <Link to="/stories" className="hover:text-background-50 transition-colors">
            Stories From the Soil
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-background-50">Share Your Story</span>
        </nav>

        <div className="flex items-center gap-3 mb-5">
          <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" />
          <span className="h-px w-10 bg-accent-400"></span>
          <span className="text-xs font-semibold tracking-[0.28em] uppercase text-accent-300">
            Your Voice, Our Journal
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl leading-[1.05] text-background-50 font-semibold max-w-3xl">
          Share Your <span className="italic text-accent-300">Story</span> From the Soil.
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-100 leading-relaxed max-w-2xl">
          Visited a farm, met a farmer, or carry a memory of the land? Send it to us. Every
          submission is read by a real person, and the best stories join our public journal.
        </p>
      </div>
    </section>
  );
}